import propDescriptions from './propDescriptions.json';
import config from './config';

function parseString(str) {
  const result = [];

  for (let i = 0; i < str.length; i++) {
    if (str.charAt(i) === '<') {
      if (str.charAt(i + 1) === "'") {
        result.push('<pre class="data-type data-type-string">');
      } else {
        result.push('<pre>');
      }
    } else if (str.charAt(i) === '>') {
      result.push('</pre>');
    } else {
      result.push(str.charAt(i));
    }
  }

  return result.join('');
}

function parseDefault(str) {
  if (str instanceof Array) {
    return `<pre class="data-type data-type-array">[${str.toString()}]</pre>`;
  }

  if (str instanceof Object) {
    return `<pre class="data-type data-type-object">${JSON.stringify(str)}</pre>`;
  }

  if (typeof str === 'string') {
    return `<pre class="data-type data-type-string">'${str}'</pre>`;
  }

  if (typeof str === 'number') {
    return `<pre class="data-type data-type-number">${str}</pre>`;
  }

  if (typeof str === 'boolean') {
    return `<pre class="data-type data-type-boolean">${str}</pre>`;
  }
}

function parseChildComponentName(componentName, childComponentName, joinChildComponentName) {
  let childName = `${componentName}.${childComponentName.split(componentName)[1]}`;

  if (joinChildComponentName) {
    childName = childName.split('.').join('');
  }

  return `This prop is for ${childName}. `;
}

export default (components, componentName, ChildComponent, childComponentName, joinChildComponentName) => {
  const props = [];

  components.forEach(({ component: comp, componentName: compName }) => {
    const compProps = {
      component: compName,
      props: [],
    };

    // eslint-disable-next-line
    for (let prop in propDescriptions[compName]) {
      const propObj = {
        name: prop,
        type: parseString(propDescriptions[compName][prop].type),
        default: comp.defaultProps && parseDefault(comp.defaultProps[prop]),
        description: parseString(propDescriptions[compName][prop].description),
      };

      compProps.props.push(propObj);
    }

    props.push(compProps);
  });

  if (ChildComponent && childComponentName) {
    // eslint-disable-next-line
    for (let prop in ChildComponent.propTypes) {
      if (!propDescriptions[childComponentName][prop]) {
        throw new Error('In child component. Prop not found. Make sure you typed it correctly');
      }

      const propObj = {
        name: prop,
        type: propDescriptions[childComponentName] && parseString(propDescriptions[childComponentName][prop].type),
        default: ChildComponent.defaultProps && parseDefault(ChildComponent.defaultProps[prop]),
        description:
          propDescriptions[childComponentName] &&
          `<strong>${parseChildComponentName(
            componentName,
            childComponentName,
            joinChildComponentName
          )}</strong>${parseString(propDescriptions[childComponentName][prop].description)}`,
      };

      props[0].props.push(propObj);
    }
  }

  return {
    name: componentName,
    githubLink: config.getGithubLink(componentName),
    storybookLink: config.getStorybookLink(componentName),
    emeraldLink: config.getEmeraldLink(componentName),
    importCode: config.getImportCode(components),
    propsList: props,
  };
};
